import React, { useContext, useEffect } from 'react';
import AuthContext, { CacheContext } from '../contexts';

import '../styles/partyHistory.css';
import PartyCard from './PartyCard';


const PartyHistory = () => {
    const { user } = useContext(AuthContext);
    const { setActiveParty } = useContext(CacheContext);
   
    useEffect(() => {
        setActiveParty(null);
    },[]);

    return (
        <div className="App">
            <header className="App-header">
                <div className="page-title-container">
                    <h1>Party History</h1>
                    <p className="subtitle">Relive the memories</p>
                </div>
                {
                    user?.partyHistory
                    ?
                        user.partyHistory.map(partyId => {
                            return (<PartyCard partyId={partyId} key={partyId} />
                            )
                        })

                    :
                        <div>No Party History</div>   
                
                }

            </header>
        </div>
    );
};

export default PartyHistory;
